export const RangeStatusConstants = {
    RWF: '9BB46899-F236-47FE-B5BB-1B12C3726226'.toLowerCase(),
    DECLINED: '7DFA27A3-CDBC-42BB-8628-75663F2E7957'.toLowerCase(),
    PENDING: 'AABDA2A8-FA17-4476-916D-8B03757A1A36'.toLowerCase(),
    APPROVED: '6E967645-58CF-4750-BF24-DAE719D3813E'.toLowerCase(),
}